import { useState } from 'react';
import Text from 'components/v4/Text';
import { MdFileCopy } from 'react-icons/md';
import { HStack, IconButton, Tooltip, Box } from '@chakra-ui/react';
import { iconStyling } from '../agGridStyles';

const CopyCellRenderer = ({
    value,
    valueFormatted,
    tooltip,
    leftAdornment,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const formattedValue = valueFormatted ?? value;
    return (
        <HStack
            width="100%"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            {leftAdornment}
            <Tooltip label={tooltip}>
                <Box isTruncated>
                    <Text isTruncated>{formattedValue}</Text>
                </Box>
            </Tooltip>
            {isHovered && (
                <Tooltip label="Copy to clipboard">
                    <IconButton
                        sx={iconStyling}
                        variant="ghost"
                        onClick={() => {
                            navigator.clipboard.writeText(value);
                        }}>
                        <MdFileCopy />
                    </IconButton>
                </Tooltip>
            )}
        </HStack>
    );
};

export default CopyCellRenderer;
